export class AppSettings {
  public static readonly DATE_FORMAT = 'yyyy-MM-dd';
  public static readonly DATE_TIME_FORMAT = 'yyyy-MM-dd HH:mm:ss';
  public static readonly TITLE_PREFIX = 'PRO.CONNECT';
}
